import { getDefaultLogo } from "@/utils/utils";
import { Card, Col, Row } from "antd";
import { useBranding } from "../../../modules/branding/store";
import styles from "./AnonymousContentWrapper.module.scss";

interface Props {
  children: React.ReactNode;
}

export const AnonymousContentWrapper = (props: Props) => {
  const branding = useBranding();

  const logoUrl = branding?.logoResourcePath ? `/images/${branding.logoResourcePath}` : getDefaultLogo("dark");

  return (
    <div className={styles.wrapper}>
      <img className={styles.appLogo} src={logoUrl} alt="App Logo" />
      <Row justify="center">
        <Col flex="500px">
          <Card>{props.children}</Card>
        </Col>
      </Row>
    </div>
  );
};
